<template>
    <div class="box_report shadow_report">
        <ReportPreview
            :item="item"
            :isAchievement="isAchievement"
            class="box_report-preview"
        />
        <div class="box_report-data">
            <div class="box_report-data-top">
                <a
                    class="box_report-data-top-report_link"
                    target="_blank"
                    rel="noopener noreferrer"
                    :href="`https://reporting.${rsvDomain}/api/v1/report/${item.uid}`"
                    >{{ item.testName | ellipsis(isMobile ? 75 : 240) }}</a
                >
            </div>
            <div class="box_report-data-bottom">
                <span class="box_report-data-bottom-report_date"
                    >{{ item.createdAtDate }}
                </span>
                <span class="box_report-data-bottom-report_time">{{
                    item.createdAtTime
                }}</span>
            </div>
        </div>
        <div class="box_report-download">
            <a
                :href="`https://reporting.${rsvDomain}/api/v1/report/${item.uid}?download=true`"
                ><img
                    src="../../../../../assets/images/icons/download_report.png"
            /></a>
        </div>
    </div>
</template>

<script>
const getters = ['isMobile'];

import { mapGetters } from 'vuex';
import ReportPreview from '../../../../report-preview/ReportPreview.vue';

export default {
    name: 'ReportingItem',
    components: {
        ReportPreview,
    },
    props: {
        item: Object,
        isAchievement: Boolean,
    },
    computed: {
        ...mapGetters(getters),
        rsvDomain() {
            return window.rsvDomain || 'rsv.ru';
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/mrem';

.shadow_report {
    -webkit-box-shadow: 0px 0px 10px rgba(131, 134, 163, 0.3);
    -moz-box-shadow: 0px 0px 10px rgba(131, 134, 163, 0.3);
    box-shadow: 0px 0px 10px rgba(131, 134, 163, 0.3);
}

.box_report {
    background-color: #ffffff;
    border-radius: rem(10);
    padding: rem(16);
    display: block;
    margin-bottom: rem(32);
    display: flex;

    @include on-mobile {
        padding: mrem(12) mrem(8);
        margin-top: mrem(8);
        margin-bottom: rem(16);
        background-color: white;
        box-shadow: 0 mrem(2) mrem(8) rgba(155, 161, 166, 0.23626);
        border-radius: mrem(10);
    }

    &-preview {
        @include on-desktop {
            width: rem(155);
            min-width: rem(155);
            max-width: rem(155);
        }

        @include on-mobile {
            width: mrem(155);
            min-width: mrem(155);
            max-width: mrem(155);
        }
    }

    &-data {
        flex: 1 1 auto;
        padding-top: rem(8);
        margin-left: rem(16);
        display: flex;
        flex-direction: column;

        @include on-mobile {
            margin-left: mrem(16);
        }

        &-top {
            flex: 1 1 auto;

            &-report_link {
                color: #000000;
                font-weight: 400;
                font-size: rem(16);

                @include on-mobile {
                    font-size: mrem(16);
                }
            }
        }

        &-bottom {
            flex: 0 0 rem(12);
            font-size: rem(12);
            margin-top: rem(12);

            @include on-mobile {
                font-size: mrem(12);
                margin-top: mrem(12);
            }

            &-report_date {
                color: #98a0a9;
            }

            &-report_time {
                color: #d2d5d9;
            }
        }
    }

    &-download {
        flex: 0 0 rem(32);
        padding-left: rem(16);

        @include on-mobile {
            flex: 0 0 mrem(32);
            padding-left: mrem(16);
        }
    }
}
</style>
